/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as CheckboxGroupDefault } from './checkbox-group-default.story';
export { default as CheckboxGroupDisabled } from './checkbox-group-disabled.story';
export { default as CheckboxGroupError } from './checkbox-group-error.story';
export { default as CheckboxGroupOptional } from './checkbox-group-optional.story';
export { default as CheckboxGroupRequired } from './checkbox-group-required.story';
export { default as CheckboxGroupVisuallyHiddenLabel } from './checkbox-group-visually-hidden-label.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import CheckboxGroupDefaultSrcRaw from './checkbox-group-default.story?raw';
import CheckboxGroupDisabledSrcRaw from './checkbox-group-disabled.story?raw';
import CheckboxGroupErrorSrcRaw from './checkbox-group-error.story?raw';
import CheckboxGroupOptionalSrcRaw from './checkbox-group-optional.story?raw';
import CheckboxGroupRequiredSrcRaw from './checkbox-group-required.story?raw';
import CheckboxGroupVisuallyHiddenLabelSrcRaw from './checkbox-group-visually-hidden-label.story?raw';

export const CheckboxGroupDefaultSrc = removeLicenseHeader(
  CheckboxGroupDefaultSrcRaw,
);
export const CheckboxGroupDisabledSrc = removeLicenseHeader(
  CheckboxGroupDisabledSrcRaw,
);
export const CheckboxGroupErrorSrc = removeLicenseHeader(
  CheckboxGroupErrorSrcRaw,
);
export const CheckboxGroupOptionalSrc = removeLicenseHeader(
  CheckboxGroupOptionalSrcRaw,
);
export const CheckboxGroupRequiredSrc = removeLicenseHeader(
  CheckboxGroupRequiredSrcRaw,
);
export const CheckboxGroupVisuallyHiddenLabelSrc = removeLicenseHeader(
  CheckboxGroupVisuallyHiddenLabelSrcRaw,
);
